import { registerComponent } from '@gig/magic-common';
import { default as ResponsibleGamingModalComponent } from './responsible-gaming-modal.vue?shadowMode';

export const ResponsibleGamingModal = registerComponent(
    ResponsibleGamingModalComponent,
);
